import { createStyles, makeStyles } from '@material-ui/core';
import { COLORS } from 'shared/constants/COLORS';
const { PLAIN_TEXT, DARK_FIELDS_FLOATING_CALENDAR_HEADER, DARK_FIELDS_FLOATING_CALENDAR_BODY } = COLORS;

export const useStyles = makeStyles((theme) =>
  createStyles({
    dialogContent: {
      padding: '32px 64px !important ',
      [theme.breakpoints.down(960)]: {
        padding: '20px 0px !important ',
      },
    },
    titleContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(4),
    },
    datePicker: {
      backgroundColor: theme.palette.type === 'dark' ? `${DARK_FIELDS_FLOATING_CALENDAR_HEADER} !important` : '#fff', //header and bottom of calendar
      '&.mbsc-material.mbsc-calendar-controls': {
        backgroundColor: 'transparent !important',
      },
      '&.mbsc-material-dark.mbsc-datepicker-inline .mbsc-calendar-slide': {
        backgroundColor: `${DARK_FIELDS_FLOATING_CALENDAR_BODY} !important`, // dates background of calendar
      },
      '& .mbsc-range-day:after': {
        backgroundColor: `${theme.palette.primary.main} !important`,
      },
      '& .mbsc-material-dark.mbsc-selected .mbsc-calendar-cell-text': {
        backgroundColor: `${theme.palette.primary.main} !important`,
        borderColor: `${theme.palette.primary.main} !important`,
        color: PLAIN_TEXT, // text color of the chosen day,
      },
      '& .mbsc-material.mbsc-icon-button .mbsc-icon': {
        color: `${theme.palette.primary.main}`,
      },
    },
    buttonContainer: {
      marginTop: theme.spacing(6),
      display: 'flex',
      justifyContent: 'center',
    },
    closeIcon: {
      position: 'absolute',
      top: '20px',
      right: '25px',
      cursor: 'pointer',
    },
  }),
);
